import {SHOW_MESSAGE_SECONDS} from '../action/messageActions';

export const initialLoaderState = {
    messages: []
};

export default function messageReducer(state = initialLoaderState, action = {
    message: {},
    type: ''
}) {
    if (action.type === 'ADD_MESSAGE') {
        const nowInMilliseconds = (new Date()).getTime();
        return {
            ...state,
            messages: [
                // Remove older messages
                ...state.messages.filter(message => message.created > (nowInMilliseconds - 1000 * SHOW_MESSAGE_SECONDS)),
                {
                    ...action.data,
                    created: nowInMilliseconds
                }
            ]
        };
    } else if (action.type === 'CLEAR_MESSAGES') {
        return {
            ...state,
            messages: []
        };
    }

    return state;
}
